import React from 'react';
import { BookOpenCheckIcon, GemIcon, ScrollTextIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { Section } from './Shared';
type Tome = {
  number: string;
  title: string;
  icon: React.ElementType;
  features: string[];
};
const materialPreviews = ['Fichas de evaluación energética inicial incluidas en el Mega Pack', 'Mapa completo de imposición de cristales en camilla', 'Sistema de los 5 Escudos de Protección para el terapeuta', 'Guía de diagnóstico energético por chakra', 'Fichas de seguimiento del paciente sesión por sesión', 'Diccionario de más de 100 cristales con propiedades y limpieza', 'Protocolo de armonización completa de los 7 chakras', 'Checklist de apertura y cierre energético del consultorio', 'Scripts profesionales para comunicar tus precios con seguridad', 'Certificado imprimible de finalización del recorrido formativo'];
const tomes: Tome[] = [{
  number: 'I',
  title: 'Manual Maestro de Gemoterapia Aplicada',
  icon: BookOpenCheckIcon,
  features: ['Fundamentos del trabajo energético con cristales', 'Cómo funcionan los cristales en el campo energético humano', 'Principios de resonancia y frecuencia vibracional', 'Selección, programación y limpieza de cristales', 'Más de 50 cristales con fichas técnicas completas', 'Contraindicaciones y consideraciones éticas', 'Cómo preparar el espacio terapéutico', 'Qué decirle al paciente en cada momento de la sesión']
}, {
  number: 'II',
  title: 'El Libro de los Protocolos de Sesión',
  icon: ScrollTextIcon,
  features: ['Protocolo de Calma Profunda', 'Protocolo del Corazón Abierto', 'Protocolo de Arraigo y Presencia', 'Protocolo de la Voz Liberada', 'Protocolo de Confianza y Propósito', 'Protocolo de Liberación Profunda', 'Protocolo de Renovación Energética', 'Protocolo de Transición y Cambio', 'Protocolo del Perdón', 'Protocolo de Abundancia', 'Protocolo de Apertura Espiritual', 'Protocolo de Armonización Completa de los 7 Chakras']
}, {
  number: 'III',
  title: 'El Escudo del Terapeuta',
  icon: ShieldCheckIcon,
  features: ['Por qué los terapeutas absorben energía y cómo funciona ese proceso', 'Los 3 tipos de absorción energética: emocional, física y de campo', 'Los 5 Escudos de Protección activa durante la sesión', 'Protocolo de limpieza rápida entre pacientes', 'Protocolo de limpieza media y profunda', 'Rituales de cierre y recuperación al final del día', 'Señales de alerta nivel 1, 2 y 3 del campo del terapeuta', 'Los 8 cristales esenciales del terapeuta', 'Cómo separar tu energía personal de la energía del trabajo']
}, {
  number: 'IV',
  title: 'Cristales y Chakras',
  icon: GemIcon,
  features: ['Sistema completo de los 7 chakras aplicado a la Gemoterapia', 'Descripción, correspondencias y señales de desequilibrio de cada chakra', 'Cristales específicos para cada centro energético', 'Protocolo individual para cada uno de los 7 chakras', 'Mapa completo de imposición de cristales en camilla', 'Sistema de diagnóstico energético básico por síntoma', 'Protocolo de armonización completa de los 7 chakras', 'Recomendaciones post-sesión por chakra trabajado']
}];
const bonuses = [{
  number: '01',
  title: 'Guía Visual de Más de 100 Cristales',
  image: 'https://cdn.magicpatterns.com/uploads/3QFRLx5afNfZSPSTJyhF6L/Screenshot_20260804-095444~2.png'
}, {
  number: '02',
  title: 'Fichas Profesionales de Seguimiento del Paciente',
  image: 'https://cdn.magicpatterns.com/uploads/vN6TnqHXkgYZj1m3zHsoAB/ChatGPT_Image_4_ago_2026,_01_36_48.png'
}, {
  number: '03',
  title: 'Guía de Limpieza Energética de Espacios',
  image: 'https://cdn.magicpatterns.com/uploads/gp4xo7QnUBTXg5xZTJDRDG/ChatGPT_Image_4_ago_2026,_01_40_21.png'
}, {
  number: '04',
  title: 'Masterclass PDF: Cómo Cobrar Más por tus Sesiones',
  image: 'https://cdn.magicpatterns.com/uploads/wp1as1itMjSYNmrPTxg6ia/ChatGPT_Image_4_ago_2026,_01_43_20.png'
}, {
  number: '05',
  title: 'Certificado de Excelencia en Gemoterapia Holística',
  image: 'https://cdn.magicpatterns.com/uploads/sDRjxdh2ACvMPzdx2xv6cj/Screenshot_20260804-095551~2.png'
}];
export function PackContents() {
  return <Section id="contenido" data-id="element-198" data-mp="385qsd1dn57t4">
      <div className="mb-9 text-center" data-id="element-199" data-mp="384yybuzozi4y">
        <p className="mb-2 text-sm font-bold uppercase tracking-[.18em] text-brand-goldDark" data-id="element-200" data-mp="3883c9k2yls8t">🎁 Colección profesional</p>
        <h2 className="font-display text-3xl font-bold text-brand-purpleDark md:text-5xl" data-id="element-201" data-mp="2yfxiq5x272ri">
          4 Tomos Principales + 5 Bonus Estratégicos
        </h2>
        <p className="mt-3 text-base text-brand-muted md:text-lg" data-id="element-202" data-mp="3m48a8igv7q34">Más de 160 páginas — Todo resuelto.</p>
      </div>

      <div className="mx-auto mb-12 max-w-6xl" data-id="element-203" data-mp="3qykzxa8xpxnb">
        <div className="mb-5 text-center" data-id="element-204" data-mp="1fgr75mrpenna">
          <p className="font-serif text-xl font-bold text-brand-purpleDark md:text-2xl" data-id="element-205" data-mp="1ffg45p631jx8">
            Mirá una muestra del material por dentro
          </p>
          <p className="mt-1 text-sm text-brand-muted" data-id="element-206" data-mp="1p7ly34fwabf2">
            Protocolos, fichas, guías y recursos listos para tu consultorio.
          </p>
        </div>
        <div className="mx-auto max-w-[240px] overflow-hidden rounded-2xl border-2 border-brand-gold/40 bg-brand-purpleDark shadow-xl" data-id="element-207" data-mp="1kalr8rb814mw">
          <video src="https://cdn.magicpatterns.com/uploads/6MjgFVPUjKiKexgLj4p6et/video_landing_magic_patterns_optimizado.mp4" autoPlay loop muted playsInline className="h-full w-full object-cover" data-id="element-208" data-mp="rkdh9mqu9qje" />
        </div>
      </div>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-209" data-mp="2gxgypx97dnj1">
        {tomes.map(tome => {
        const Icon = tome.icon;
        return <article key={tome.number} className="glass-panel rounded-2xl p-5" data-id="element-210" data-mp="19mixphaubo0x">
              <div className="mb-4 flex items-start gap-3" data-id="element-211" data-mp="1eku4fj5u9iex">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-brand-purple text-brand-goldLight shadow-sm ring-1 ring-brand-gold/40" data-id="element-212" data-mp="1ej9a9unfs1hl">
                  <Icon className="h-7 w-7" data-id="element-213" data-mp="1nkqzq3mqhfiy" />
                </div>
                <div data-id="element-214" data-mp="qvrnyemxxvm0">
                  <p className="text-[10px] font-bold tracking-[.16em] text-brand-goldDark" data-id="element-215" data-mp="qwaxp82ftdoy">TOMO {tome.number}</p>
                  <h3 className="font-serif text-base font-bold leading-tight text-brand-purpleDark" data-id="element-216" data-mp="vve1kp6oldvc">{tome.title}</h3>
                </div>
              </div>
              <ul className="space-y-2 text-xs leading-snug text-brand-text" data-id="element-217" data-mp="14mo3p4vrqibn">
                {tome.features.map(feature => <li key={feature} className="flex gap-2" data-id="element-218" data-mp="83yw4njlygfv">
                    <span className="font-bold text-brand-goldDark" data-id="element-219" data-mp="c6lsn1r84pje">✓</span>
                    <span data-id="element-220" data-mp="c4is3nsg3e0f">{feature}</span>
                  </li>)}
              </ul>
            </article>;
      })}
      </div>

      <div className="mb-6 mt-12 text-center" data-id="element-221" data-mp="3vt5lc09okza2">
        <h3 className="font-serif text-xl font-bold text-brand-purpleDark md:text-2xl" data-id="element-222" data-mp="3vraw49rdml06">
          🎁 5 BONUS ESTRATÉGICOS — <span className="text-brand-goldDark" data-id="element-223" data-mp="3mspj0u4oby6s">SIEMPRE INCLUIDOS</span>
        </h3>
      </div>

      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5" data-id="element-224" data-mp="3mv1virrnxgcg">
        {bonuses.map(bonus => <article key={bonus.number} className="overflow-hidden rounded-xl border border-brand-purple/20 bg-white shadow-sm" data-id="element-225" data-mp="3d2e5qgz3ocn8">
            <div className="relative aspect-[3/4] overflow-hidden bg-brand-purpleDark" data-id="element-226" data-mp="381gl7xqmb6ik">
              <img src={bonus.image} alt={`Portada del Bonus ${bonus.number}: ${bonus.title}`} loading="lazy" className="h-full w-full object-cover object-top transition-transform duration-500 hover:scale-[1.03]" data-id="element-227" data-mp="3404tnmo6ob7q" />
              <span className="absolute right-0 top-0 rounded-bl-lg bg-brand-goldBright px-2 py-1 text-[9px] font-bold text-brand-purpleDark" data-id="element-228" data-mp="lw4zw28v1es3">
                GRATIS
              </span>
            </div>
            <p className="px-2 pt-2 text-center text-[10px] font-bold leading-tight text-brand-purpleDark" data-id="element-229" data-mp="cwrr7bsk8u8f">
              BONUS {bonus.number}
            </p>
            <p className="px-2 pb-2 text-center text-[10px] leading-tight text-brand-muted" data-id="element-230" data-mp="33t2ltx2d3ot">
              {bonus.title}
              <span className="mt-0.5 block font-bold text-brand-purple" data-id="element-231" data-mp="7x5c0wt693wz">Valor real → GRATIS</span>
            </p>
          </article>)}
      </div>

      <div className="mt-7 text-center" data-id="element-232" data-mp="3uanfqq51lym9">
        <p className="inline-block rounded-full border border-brand-gold/60 bg-white px-5 py-3 text-sm font-medium text-brand-text" data-id="element-233" data-mp="3uboqeti5cj3g">
          Todo el valor de los bonus <span className="font-bold text-brand-purple" data-id="element-234" data-mp="3lb0atud3uaog">incluido con tu Mega Pack</span>
        </p>
      </div>
    </Section>;
}